import { z } from 'zod';

import type { ActivityParams } from '../hooks/use-activity';

const DAY = /^\d{4}-\d{2}-\d{2}$/;

/** Filters live in the URL so a filtered log can be shared; "load more" pages stay in memory. */
export const activitySearchSchema = z.object({
  actorId: z.string().optional().catch(undefined),
  action: z.string().trim().max(80).optional().catch(undefined),
  entityType: z.string().trim().max(80).optional().catch(undefined),
  /** One record's history, as a product's Change history link opens it. */
  entityId: z.string().optional().catch(undefined),
  storeId: z.string().optional().catch(undefined),
  from: z.string().regex(DAY).optional().catch(undefined),
  to: z.string().regex(DAY).optional().catch(undefined),
});

export type ActivitySearch = z.infer<typeof activitySearchSchema>;

/** Days are whole: `to` covers the full day, both in UTC as the API compares timestamps. */
export function activityParams(search: ActivitySearch): ActivityParams {
  return {
    limit: 50,
    ...(search.actorId ? { actorId: search.actorId } : {}),
    ...(search.action ? { action: search.action } : {}),
    ...(search.entityType ? { entityType: search.entityType } : {}),
    ...(search.entityId ? { entityId: search.entityId } : {}),
    ...(search.storeId ? { storeId: search.storeId } : {}),
    ...(search.from ? { from: `${search.from}T00:00:00.000Z` } : {}),
    ...(search.to ? { to: `${search.to}T23:59:59.999Z` } : {}),
  };
}

/** Entity types the log knows a screen for. */
export const ENTITY_TYPES = [
  'organization',
  'store',
  'membership',
  'role',
  'product',
  'store_product',
  'order',
  'customer',
  'api_key',
  'webhook_endpoint',
] as const;
